import { Link } from 'react-router-dom';
import { Progress, Stack, TableColumns } from '@ff-it/ui';
import type { Guarantee } from 'modules/guarantee/types';
import { sepFormat } from 'utilities';
import { TitleContainer } from 'components/TitleContainer';

import { DeadlineDate } from 'components/DeadlineDate';

function progressVariant(progress: number, value: number): 'danger' | 'warning' | 'success' {
  if (value > progress) {
    return 'success';
  }
  if (progress - value >= 10) {
    return 'danger';
  }
  return 'warning';
}

export const columns: TableColumns<Guarantee> = [
  {
    content: 'Number',
    key: 'number',
    width: 90,
    render: ({ id, number }) => <Link to={`${id}`}>{number}</Link>,
  },
  {
    content: 'Title',
    key: 'title',
  },
  {
    content: 'Type',
    key: 'type',
    width: 110,
  },
  {
    key: 'date_to',
    content: 'Time left',
    cellProps: {
      className: 'py-1',
    },
    width: 120,
    sortable: true,
    render: ({ date_to, execution: { time_left } }) => {
      return (
        <Stack direction="vertical" textSize="xs" space="0.5" lineHeight="1">
          <DeadlineDate deadline={date_to} />
          {time_left ? `${time_left}%` : null}
        </Stack>
      );
    },
  },
  {
    content: 'Target, €',
    cellProps: { textAlign: 'end' },
    key: 'execution.target',
    render: ({ execution: { target } }) => sepFormat(target),
    width: 120,
    sortable: true,
  },
  {
    content: 'Planned, €',
    key: 'execution.planned',
    render: ({ execution: { planned } }) => sepFormat(planned),
    cellProps: { textAlign: 'end' },
    width: 120,
    sortable: true,
  },
  {
    content: 'Approved',
    key: 'execution.approved_progress',
    width: 160,
    sortable: true,
    cellProps: { className: 'py-1' },
    render: ({ execution: { time_progress, approved_progress, approved } }: Guarantee) => {
      const title = approved_progress ? (
        <Progress
          variant={progressVariant(Number.parseFloat(time_progress), Number.parseFloat(approved_progress))}
          value={Number.parseFloat(approved_progress)}
        />
      ) : null;
      return <TitleContainer title={title} subtitle={sepFormat(approved)} />;
    },
  },
];
